import {
  V2ListBusinessUnitsForAccountApiArg,
  useV2ListBusinessUnitsForAccountQuery,
} from "@generated";
import type { BusinessUnit } from "../types";

export interface UseBusinessUnitsListArgs {
  page?: V2ListBusinessUnitsForAccountApiArg["page"];
  filter?: V2ListBusinessUnitsForAccountApiArg["filter"];
}

export interface BusinessUnitsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useBusinessUnitsList = ({
  page,
  filter,
}: UseBusinessUnitsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListBusinessUnitsForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: BusinessUnit[] = (data?.data ?? []).map((bu) => ({
    id: String(bu.id),
    name: bu.attributes?.name ?? "",
    externalName: bu.attributes?.["external-name"],
    streetAddress: bu.attributes?.["street-address"],
    street2: bu.attributes?.street2,
    city: bu.attributes?.city,
    state: bu.attributes?.state,
    postalCode: bu.attributes?.["postal-code"],
  }));

  const pageMeta: BusinessUnitsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useBusinessUnitsList;
